import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';
// import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [accessToken, setToken] = useState(localStorage.getItem('token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        if (savedUser && accessToken) {
            setUser(JSON.parse(savedUser));
        }
        setLoading(false);
    }, [accessToken]);

    const login = (userData, accessToken) => {
        localStorage.setItem('token', accessToken);
        localStorage.setItem('user', JSON.stringify(userData));
   
        setToken(accessToken);
        setUser(userData);
    };

const logout = async () => {
console.log("Logging out user at AuthContext:");
  try {
    await api.post("/auth/logout");
  } catch (err) {}
  // navigate("/login", { replace: true });
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  setUser(null);
  setToken(null);
};
    // Global helper to check if the user is restricted to a specific sub-county
    
    return (
        <AuthContext.Provider value={{ 
            user, 
            accessToken, 
            login, 
            logout, 
            loading
        }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

//export const useAuth = () => useContext(AuthContext);